import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  ButtonGroup,
  Card,
  CardBody,
} from "reactstrap";
import moment from "moment";
import Center from "react-center";
import * as Icons from "react-feather";
import Axios from "axios";
import { urlAPI, getUser, getToken } from "utility/Common";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import { useDebounce } from "use-debounce";
import NumberFormat from "react-number-format";
import ModalSelected from "./component/ModalSelected";
import ModalWarning from "./component/ModalWarning";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import PrintComponent from "../../print/PrintComponent";

const initDataState = {
  // NOSLIP: "",
  // NOBUKTI: "",
  // TGL_ENTRY: "",
  TGL_TRANSAKSI: moment().format("YYYY-MM-DD"),
  ACCOUNT: "",
  KOMPILATOR: "",
  KEPADA: null,
  NAMASUPPLIER: "",
  ALAMAT: "",
  KOTA: "",
  DK: "K",
  JENIS: "Hutang",
  NOTB1: "",
  NOTB2: "",
  NOTB3: "",
  NOTB4: "",
  NOTB5: "",
  NOTB6: "",
  NOTB7: "",
  NOTB8: "",
  NOTB9: "",
  NOTB10: "",
  AKUN1: "",
  AKUN2: "",
  AKUN3: "",
  AKUN4: "",
  AKUN5: "",
  AKUN6: "",
  AKUN7: "",
  AKUN8: "",
  AKUN9: "",
  AKUN10: "",
  CC1: "",
  CC2: "",
  CC3: "",
  CC4: "",
  CC5: "",
  CC6: "",
  CC7: "",
  CC8: "",
  CC9: "",
  CC10: "",
  KOMP1: "",
  KOMP2: "",
  KOMP3: "",
  KOMP4: "",
  KOMP5: "",
  KOMP6: "",
  KOMP7: "",
  KOMP8: "",
  KOMP9: "",
  KOMP10: "",
  AKT1: "",
  AKT2: "",
  AKT3: "",
  AKT4: "",
  AKT5: "",
  AKT6: "",
  AKT7: "",
  AKT8: "",
  AKT9: "",
  AKT10: "",
  KET1: "",
  KET2: "",
  KET3: "",
  KET4: "",
  KET5: "",
  KET6: "",
  KET7: "",
  KET8: "",
  KET9: "",
  KET10: "",
  D1: 0.0,
  D2: 0.0,
  D3: 0.0,
  D4: 0.0,
  D5: 0.0,
  D6: 0.0,
  D7: 0.0,
  D8: 0.0,
  D9: 0.0,
  D10: 0.0,
  K1: 0.0,
  K2: 0.0,
  K3: 0.0,
  K4: 0.0,
  K5: 0.0,
  K6: 0.0,
  K7: 0.0,
  K8: 0.0,
  K9: 0.0,
  K10: 0.0,
  Total: 0.0,
  Terbilang: "",
  // Ins_userID: getUser()?.username,
  // Ins_nmKomp: "SIRS WEB",
  Upd_userID: null,
  Upd_nmKomp: null,
  // Batal: 0,
  // Btl_userID: null,
  // Btl_nmKomp: null,
  // RowId: "",
  // TGLENTRY: null,
  // sts_transfer: null,
  // sts_delete: null,
  // tgl_transfer: "",
  // tgl_delete: "",
};
export default function KasKeluar(props) {
  const {
    noSlip,
    noBukti,
    selectorJenis,
    selectorAccount,
    loadingAccount,
    selectorCostCenter,
    selectorKompilator,
    loadingKompilatorDanCC,
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const [dataState, setDataState] = useState(initDataState);

  const [loadingSave, setLoadingSave] = useState(false);

  const [openModalSelect, setOpenModalSelect] = useState(false);
  const [dataModalSelect, setDataModalSelect] = useState([]);

  const [openWarning, setOpenWarning] = useState(false);

  const [openPrint, setOpenPrint] = useState(false);
  const [dataPrint, setDataPrint] = useState(null);

  const [loadingLoad, setLoadingLoad] = useState(false);

  const [selectorTransJenis] = useState([
    { value: "Kasbon", label: "KASBON" },
    { value: "KasKecil", label: "KAS KECIL" },
    { value: "UangMuka", label: "UANG MUKA" },
  ]);

  const fetchDataForEdit = () => {
    Axios.get(
      urlAPI +
        "/v1/kasbank/dataforedit?id=" +
        JSON.stringify({
          noslip: noSlip,
          nobukti: noBukti,
        }),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        if (response?.data?.result?.length > 0) {
          const dataFetch = response?.data?.result[0];
          const {
            NOSLIP,
            NOBUKTI,
            TGL_ENTRY,
            RowId,
            TGLENTRY,
            sts_transfer,
            sts_delete,
            tgl_transfer,
            tgl_delete,
            Ins_userID,
            Ins_nmKomp,
            Batal,
            Btl_userID,
            Btl_nmKomp,
            ...filteredState
          } = dataFetch;
          setDataState({
            ...filteredState,
            D1: Number(filteredState?.D1),
            D2: Number(filteredState?.D2),
            D3: Number(filteredState?.D3),
            D4: Number(filteredState?.D4),
            D5: Number(filteredState?.D5),
            D6: Number(filteredState?.D6),
            D7: Number(filteredState?.D7),
            D8: Number(filteredState?.D8),
            D9: Number(filteredState?.D9),
            D10: Number(filteredState?.D10),
            K1: Number(filteredState?.K1),
            K2: Number(filteredState?.K2),
            K3: Number(filteredState?.K3),
            K4: Number(filteredState?.K4),
            K5: Number(filteredState?.K5),
            K6: Number(filteredState?.K6),
            K7: Number(filteredState?.K7),
            K8: Number(filteredState?.K8),
            K9: Number(filteredState?.K9),
            K10: Number(filteredState?.K10),
            Total: Number(filteredState?.Total),
            TGL_TRANSAKSI: moment(filteredState?.TGL_TRANSAKSI).format(
              "YYYY-MM-DD"
            ),
          });
        }

        setLoadingLoad(false);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingLoad(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoadingLoad(false);
        }
      });
  };

  useEffect(() => {
    setLoadingLoad(true);
    fetchDataForEdit();
  }, []);

  const handleSimpan = (print) => {
    Axios.put(
      urlAPI + "/v1/kasbank/edit",
      {
        NOSLIP: noSlip,
        NOBUKTI: noBukti,
        DATA: {
          ...dataState,
          Terbilang:
            angkaTerbilang(Number(dataState?.Total)).toUpperCase() + " RUPIAH",
          Upd_userID: getUser()?.username,
          Upd_nmKomp: "SIRS WEB",
          TGL_TRANSAKSI: moment(dataState?.TGL_TRANSAKSI).format("YYYY-MM-DD"),
          D1: Number(dataState?.D1),
          D2: Number(dataState?.D2),
          D3: Number(dataState?.D3),
          D4: Number(dataState?.D4),
          D5: Number(dataState?.D5),
          D6: Number(dataState?.D6),
          D7: Number(dataState?.D7),
          D8: Number(dataState?.D8),
          D9: Number(dataState?.D9),
          D10: Number(dataState?.D10),
          K1: Number(dataState?.K1),
          K2: Number(dataState?.K2),
          K3: Number(dataState?.K3),
          K4: Number(dataState?.K4),
          K5: Number(dataState?.K5),
          K6: Number(dataState?.K6),
          K7: Number(dataState?.K7),
          K8: Number(dataState?.K8),
          K9: Number(dataState?.K9),
          K10: Number(dataState?.K10),
          Total: Number(dataState?.Total),
        },
      },
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        dispatch({
          type: "FILL_BERHASIL",
          berhasil: true,
          pesan: response.data.message,
        });
        setLoadingSave(false);
        setDataState(initDataState);
        if (print) {
          setDataPrint(response.data.result);
          setOpenPrint(true);
        } else {
          history.push("/keuangan/kasbank");
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingSave(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.dataState?.message,
          });
          setLoadingSave(false);
        }
      });
  };

  return (
    <>
      <PrintComponent
        handleClose={() => {
          setDataPrint(null);
          setOpenPrint(false);
          history.push("/keuangan/kasbank");
        }}
        open={openPrint}
        data={dataPrint}
      />
      <ModalWarning
        onOk={(event) => {
          setOpenWarning(false);
        }}
        open={openWarning}
      />
      <ModalSelected
        open={openModalSelect}
        setOpen={(event) => setOpenModalSelect(event)}
        data={dataModalSelect}
        setData={(event) => setDataModalSelect(event)}
        kepada={dataState?.KEPADA}
        selectorAccount={selectorAccount}
        loadingAccount={loadingAccount}
        selectorCostCenter={selectorCostCenter}
        selectorKompilator={selectorKompilator}
        loadingKompilatorDanCC={loadingKompilatorDanCC}
        handleDone={() => {
          if (dataModalSelect[0]?.INDEX === 1) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB1: dataModalSelect[0]?.NOTB,
                AKUN1: dataModalSelect[0]?.AKUN,
                CC1: dataModalSelect[0]?.CC,
                KOMP1: dataModalSelect[0]?.KOMP,
                AKT1: dataModalSelect[0]?.AKT,
                KET1: dataModalSelect[0]?.KET,
                K1: dataModalSelect[0]?.K,
                D1: dataModalSelect[0]?.D,
                NOTB2: dataModalSelect[1]?.NOTB,
                AKUN2: dataModalSelect[1]?.AKUN,
                CC2: dataModalSelect[1]?.CC,
                KOMP2: dataModalSelect[1]?.KOMP,
                AKT2: dataModalSelect[1]?.AKT,
                KET2: dataModalSelect[1]?.KET,
                K2: dataModalSelect[1]?.K,
                D2: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB1: dataModalSelect[0]?.NOTB,
                AKUN1: dataModalSelect[0]?.AKUN,
                CC1: dataModalSelect[0]?.CC,
                KOMP1: dataModalSelect[0]?.KOMP,
                AKT1: dataModalSelect[0]?.AKT,
                KET1: dataModalSelect[0]?.KET,
                K1: dataModalSelect[0]?.K,
                D1: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }

            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 2) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB2: dataModalSelect[0]?.NOTB,
                AKUN2: dataModalSelect[0]?.AKUN,
                CC2: dataModalSelect[0]?.CC,
                KOMP2: dataModalSelect[0]?.KOMP,
                AKT2: dataModalSelect[0]?.AKT,
                KET2: dataModalSelect[0]?.KET,
                K2: dataModalSelect[0]?.K,
                D2: dataModalSelect[0]?.D,
                NOTB3: dataModalSelect[1]?.NOTB,
                AKUN3: dataModalSelect[1]?.AKUN,
                CC3: dataModalSelect[1]?.CC,
                KOMP3: dataModalSelect[1]?.KOMP,
                AKT3: dataModalSelect[1]?.AKT,
                KET3: dataModalSelect[1]?.KET,
                K3: dataModalSelect[1]?.K,
                D3: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB2: dataModalSelect[0]?.NOTB,
                AKUN2: dataModalSelect[0]?.AKUN,
                CC2: dataModalSelect[0]?.CC,
                KOMP2: dataModalSelect[0]?.KOMP,
                AKT2: dataModalSelect[0]?.AKT,
                KET2: dataModalSelect[0]?.KET,
                K2: dataModalSelect[0]?.K,
                D2: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 3) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {

            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB3: dataModalSelect[0]?.NOTB,
                AKUN3: dataModalSelect[0]?.AKUN,
                CC3: dataModalSelect[0]?.CC,
                KOMP3: dataModalSelect[0]?.KOMP,
                AKT3: dataModalSelect[0]?.AKT,
                KET3: dataModalSelect[0]?.KET,
                K3: dataModalSelect[0]?.K,
                D3: dataModalSelect[0]?.D,
                NOTB4: dataModalSelect[1]?.NOTB,
                AKUN4: dataModalSelect[1]?.AKUN,
                CC4: dataModalSelect[1]?.CC,
                KOMP4: dataModalSelect[1]?.KOMP,
                AKT4: dataModalSelect[1]?.AKT,
                KET4: dataModalSelect[1]?.KET,
                K4: dataModalSelect[1]?.K,
                D4: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB3: dataModalSelect[0]?.NOTB,
                AKUN3: dataModalSelect[0]?.AKUN,
                CC3: dataModalSelect[0]?.CC,
                KOMP3: dataModalSelect[0]?.KOMP,
                AKT3: dataModalSelect[0]?.AKT,
                KET3: dataModalSelect[0]?.KET,
                K3: dataModalSelect[0]?.K,
                D3: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }

            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 4) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB4: dataModalSelect[0]?.NOTB,
                AKUN4: dataModalSelect[0]?.AKUN,
                CC4: dataModalSelect[0]?.CC,
                KOMP4: dataModalSelect[0]?.KOMP,
                AKT4: dataModalSelect[0]?.AKT,
                KET4: dataModalSelect[0]?.KET,
                K4: dataModalSelect[0]?.K,
                D4: dataModalSelect[0]?.D,
                NOTB5: dataModalSelect[1]?.NOTB,
                AKUN5: dataModalSelect[1]?.AKUN,
                CC5: dataModalSelect[1]?.CC,
                KOMP5: dataModalSelect[1]?.KOMP,
                AKT5: dataModalSelect[1]?.AKT,
                KET5: dataModalSelect[1]?.KET,
                K5: dataModalSelect[1]?.K,
                D5: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB4: dataModalSelect[0]?.NOTB,
                AKUN4: dataModalSelect[0]?.AKUN,
                CC4: dataModalSelect[0]?.CC,
                KOMP4: dataModalSelect[0]?.KOMP,
                AKT4: dataModalSelect[0]?.AKT,
                KET4: dataModalSelect[0]?.KET,
                K4: dataModalSelect[0]?.K,
                D4: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 5) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB5: dataModalSelect[0]?.NOTB,
                AKUN5: dataModalSelect[0]?.AKUN,
                CC5: dataModalSelect[0]?.CC,
                KOMP5: dataModalSelect[0]?.KOMP,
                AKT5: dataModalSelect[0]?.AKT,
                KET5: dataModalSelect[0]?.KET,
                K5: dataModalSelect[0]?.K,
                D5: dataModalSelect[0]?.D,
                NOTB6: dataModalSelect[1]?.NOTB,
                AKUN6: dataModalSelect[1]?.AKUN,
                CC6: dataModalSelect[1]?.CC,
                KOMP6: dataModalSelect[1]?.KOMP,
                AKT6: dataModalSelect[1]?.AKT,
                KET6: dataModalSelect[1]?.KET,
                K6: dataModalSelect[1]?.K,
                D6: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB5: dataModalSelect[0]?.NOTB,
                AKUN5: dataModalSelect[0]?.AKUN,
                CC5: dataModalSelect[0]?.CC,
                KOMP5: dataModalSelect[0]?.KOMP,
                AKT5: dataModalSelect[0]?.AKT,
                KET5: dataModalSelect[0]?.KET,
                K5: dataModalSelect[0]?.K,
                D5: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 6) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB6: dataModalSelect[0]?.NOTB,
                AKUN6: dataModalSelect[0]?.AKUN,
                CC6: dataModalSelect[0]?.CC,
                KOMP6: dataModalSelect[0]?.KOMP,
                AKT6: dataModalSelect[0]?.AKT,
                KET6: dataModalSelect[0]?.KET,
                K6: dataModalSelect[0]?.K,
                D6: dataModalSelect[0]?.D,
                NOTB7: dataModalSelect[1]?.NOTB,
                AKUN7: dataModalSelect[1]?.AKUN,
                CC7: dataModalSelect[1]?.CC,
                KOMP7: dataModalSelect[1]?.KOMP,
                AKT7: dataModalSelect[1]?.AKT,
                KET7: dataModalSelect[1]?.KET,
                K7: dataModalSelect[1]?.K,
                D7: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB6: dataModalSelect[0]?.NOTB,
                AKUN6: dataModalSelect[0]?.AKUN,
                CC6: dataModalSelect[0]?.CC,
                KOMP6: dataModalSelect[0]?.KOMP,
                AKT6: dataModalSelect[0]?.AKT,
                KET6: dataModalSelect[0]?.KET,
                K6: dataModalSelect[0]?.K,
                D6: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 7) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB7: dataModalSelect[0]?.NOTB,
                AKUN7: dataModalSelect[0]?.AKUN,
                CC7: dataModalSelect[0]?.CC,
                KOMP7: dataModalSelect[0]?.KOMP,
                AKT7: dataModalSelect[0]?.AKT,
                KET7: dataModalSelect[0]?.KET,
                K7: dataModalSelect[0]?.K,
                D7: dataModalSelect[0]?.D,
                NOTB8: dataModalSelect[1]?.NOTB,
                AKUN8: dataModalSelect[1]?.AKUN,
                CC8: dataModalSelect[1]?.CC,
                KOMP8: dataModalSelect[1]?.KOMP,
                AKT8: dataModalSelect[1]?.AKT,
                KET8: dataModalSelect[1]?.KET,
                K8: dataModalSelect[1]?.K,
                D8: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB7: dataModalSelect[0]?.NOTB,
                AKUN7: dataModalSelect[0]?.AKUN,
                CC7: dataModalSelect[0]?.CC,
                KOMP7: dataModalSelect[0]?.KOMP,
                AKT7: dataModalSelect[0]?.AKT,
                KET7: dataModalSelect[0]?.KET,
                K7: dataModalSelect[0]?.K,
                D7: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D8) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K8) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 8) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB8: dataModalSelect[0]?.NOTB,
                AKUN8: dataModalSelect[0]?.AKUN,
                CC8: dataModalSelect[0]?.CC,
                KOMP8: dataModalSelect[0]?.KOMP,
                AKT8: dataModalSelect[0]?.AKT,
                KET8: dataModalSelect[0]?.KET,
                K8: dataModalSelect[0]?.K,
                D8: dataModalSelect[0]?.D,
                NOTB9: dataModalSelect[1]?.NOTB,
                AKUN9: dataModalSelect[1]?.AKUN,
                CC9: dataModalSelect[1]?.CC,
                KOMP9: dataModalSelect[1]?.KOMP,
                AKT9: dataModalSelect[1]?.AKT,
                KET9: dataModalSelect[1]?.KET,
                K9: dataModalSelect[1]?.K,
                D9: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K10)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB8: dataModalSelect[0]?.NOTB,
                AKUN8: dataModalSelect[0]?.AKUN,
                CC8: dataModalSelect[0]?.CC,
                KOMP8: dataModalSelect[0]?.KOMP,
                AKT8: dataModalSelect[0]?.AKT,
                KET8: dataModalSelect[0]?.KET,
                K8: dataModalSelect[0]?.K,
                D8: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K9) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D9) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D9) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K9) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 9) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB10
            // ) {
            //   setOpenWarning(true);
            // } else {
            if (dataModalSelect?.length === 2) {
              setDataState({
                ...dataState,
                NOTB9: dataModalSelect[0]?.NOTB,
                AKUN9: dataModalSelect[0]?.AKUN,
                CC9: dataModalSelect[0]?.CC,
                KOMP9: dataModalSelect[0]?.KOMP,
                AKT9: dataModalSelect[0]?.AKT,
                KET9: dataModalSelect[0]?.KET,
                K9: dataModalSelect[0]?.K,
                D9: dataModalSelect[0]?.D,
                NOTB10: dataModalSelect[1]?.NOTB,
                AKUN10: dataModalSelect[1]?.AKUN,
                CC10: dataModalSelect[1]?.CC,
                KOMP10: dataModalSelect[1]?.KOMP,
                AKT10: dataModalSelect[1]?.AKT,
                KET10: dataModalSelect[1]?.KET,
                K10: dataModalSelect[1]?.K,
                D10: dataModalSelect[1]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataModalSelect[1]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataModalSelect[1]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataModalSelect[1]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataModalSelect[1]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8)),
              });
            } else {
              setDataState({
                ...dataState,
                NOTB9: dataModalSelect[0]?.NOTB,
                AKUN9: dataModalSelect[0]?.AKUN,
                CC9: dataModalSelect[0]?.CC,
                KOMP9: dataModalSelect[0]?.KOMP,
                AKT9: dataModalSelect[0]?.AKT,
                KET9: dataModalSelect[0]?.KET,
                K9: dataModalSelect[0]?.K,
                D9: dataModalSelect[0]?.D,
                Total:
                  dataState?.DK === "D"
                    ? Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K10) -
                      (Number(dataModalSelect[0]?.D) +
                        Number(dataState?.D1) +
                        Number(dataState?.D2) +
                        Number(dataState?.D3) +
                        Number(dataState?.D4) +
                        Number(dataState?.D5) +
                        Number(dataState?.D6) +
                        Number(dataState?.D7) +
                        Number(dataState?.D8) +
                        Number(dataState?.D10))
                    : Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D10) -
                      (Number(dataModalSelect[0]?.K) +
                        Number(dataState?.K1) +
                        Number(dataState?.K2) +
                        Number(dataState?.K3) +
                        Number(dataState?.K4) +
                        Number(dataState?.K5) +
                        Number(dataState?.K6) +
                        Number(dataState?.K7) +
                        Number(dataState?.K8) +
                        Number(dataState?.K10)),
              });
            }
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else if (dataModalSelect[0]?.INDEX === 10) {
            // if (
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB1 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB2 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB3 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB4 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB5 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB6 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB7 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB8 ||
            //   dataModalSelect[0]?.NOTB === dataState?.NOTB9
            // ) {
            //   setOpenWarning(true);
            // } else {
            setDataState({
              ...dataState,
              NOTB10: dataModalSelect[0]?.NOTB,
              AKUN10: dataModalSelect[0]?.AKUN,
              CC10: dataModalSelect[0]?.CC,
              KOMP10: dataModalSelect[0]?.KOMP,
              AKT10: dataModalSelect[0]?.AKT,
              KET10: dataModalSelect[0]?.KET,
              K10: dataModalSelect[0]?.K,
              D10: dataModalSelect[0]?.D,
              Total:
                dataState?.DK === "D"
                  ? Number(dataModalSelect[0]?.K) +
                    Number(dataState?.K1) +
                    Number(dataState?.K2) +
                    Number(dataState?.K3) +
                    Number(dataState?.K4) +
                    Number(dataState?.K5) +
                    Number(dataState?.K6) +
                    Number(dataState?.K7) +
                    Number(dataState?.K8) +
                    Number(dataState?.K9) -
                    (Number(dataModalSelect[0]?.D) +
                      Number(dataState?.D1) +
                      Number(dataState?.D2) +
                      Number(dataState?.D3) +
                      Number(dataState?.D4) +
                      Number(dataState?.D5) +
                      Number(dataState?.D6) +
                      Number(dataState?.D7) +
                      Number(dataState?.D8) +
                      Number(dataState?.D9))
                  : Number(dataModalSelect[0]?.D) +
                    Number(dataState?.D1) +
                    Number(dataState?.D2) +
                    Number(dataState?.D3) +
                    Number(dataState?.D4) +
                    Number(dataState?.D5) +
                    Number(dataState?.D6) +
                    Number(dataState?.D7) +
                    Number(dataState?.D8) +
                    Number(dataState?.D9) -
                    (Number(dataModalSelect[0]?.K) +
                      Number(dataState?.K1) +
                      Number(dataState?.K2) +
                      Number(dataState?.K3) +
                      Number(dataState?.K4) +
                      Number(dataState?.K5) +
                      Number(dataState?.K6) +
                      Number(dataState?.K7) +
                      Number(dataState?.K8) +
                      Number(dataState?.K9)),
            });
            setDataModalSelect([]);
            setOpenModalSelect(false);
            // }
          } else {
            setOpenModalSelect(false);
            setDataModalSelect([]);
          }
        }}
      />
      <Card>
        <CardBody>
          {loadingLoad ? (
            <Center>
              <h3>Meminta data dari database, Mohon tunggu...</h3>
            </Center>
          ) : (
            <>
              <Row>
                <Col lg="6" md="6" sm="12">
                  <FormGroup>
                    <Label>No Slip</Label>
                    <Input
                      type="text"
                      name="noslip"
                      id="noslip"
                      disabled={true}
                      value={noSlip}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Jenis</Label>
                    <Select
                      styles={{
                        color: "black",
                      }}
                      id="jenis"
                      name="jenis"
                      options={selectorJenis}
                      value={selectorJenis?.find(
                        (find) => find.value === dataState?.DK
                      )}
                      isDisabled={true}
                      // onChange={(e) => {
                      //   setDataState({
                      //     ...dataState,
                      //     DK: e.value,
                      //   });
                      // }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Kode Rekening</Label>
                    <Select
                      styles={{
                        color: "black",
                      }}
                      id="ACCOUNT"
                      name="ACCOUNT"
                      options={selectorAccount}
                      value={selectorAccount?.find(
                        (find) => find.value === dataState?.ACCOUNT
                      )}
                      isLoading={loadingAccount}
                      onChange={(e) => {
                        setDataState({
                          ...dataState,
                          ACCOUNT: e.value,
                        });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12">
                  <FormGroup>
                    <Label>No Bukti</Label>
                    <Input
                      type="text"
                      name="noBukti"
                      id="noBukti"
                      disabled={true}
                      value={noBukti}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Tanggal</Label>
                    <Input
                      id="TGL_TRANSAKSI"
                      name="TGL_TRANSAKSI"
                      value={dataState?.TGL_TRANSAKSI}
                      type="date"
                      onChange={(e) => {
                        setDataState({
                          ...dataState,
                          TGL_TRANSAKSI: e.target.value,
                        });
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Kompilator</Label>
                    <Select
                      styles={{
                        color: "black",
                      }}
                      id="KOMPILATOR"
                      name="KOMPILATOR"
                      options={selectorKompilator}
                      value={selectorKompilator?.find(
                        (find) => find.value === dataState?.KOMPILATOR
                      )}
                      isLoading={loadingKompilatorDanCC}
                      onChange={(e) => {
                        setDataState({
                          ...dataState,
                          KOMPILATOR: e.value,
                        });
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <FormGroup>
                <Label>Jenis Transaksi</Label>
                <Select
                  styles={{
                    color: "black",
                  }}
                  id="jenistrans"
                  name="jenistrans"
                  options={selectorTransJenis}
                  value={
                    selectorTransJenis?.find(
                      (find) => find.value === dataState?.JENIS
                    ) ?? null
                  }
                  isDisabled={true}
                />
              </FormGroup>
              {/* <FormGroup>
                <Label>No Transaksi</Label>
                <Input
                  name="NOTB1"
                  id="NOTB1"
                  type="text"
                  value={dataState?.NOTB1}
                  disabled={true}
                />
              </FormGroup> */}

              <Table striped={true}>
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>K</th>
                    <th>No Trans</th>
                    <th>Rekening</th>
                    <th>Cost Center</th>
                    <th>Kompilator</th>
                    <th>Aktivitas</th>
                    <th>Keterangan</th>
                    <th>Jumlah</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB1 !== null &&
                        dataState?.NOTB1 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 1,
                            NOTB: dataState?.NOTB1,
                            AKUN: dataState?.AKUN1,
                            CC: dataState?.CC1,
                            KOMP: dataState?.KOMP1,
                            AKT: dataState?.AKT1,
                            KET: dataState?.KET1,
                            K: dataState?.K1,
                            D: dataState?.D1,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K1) > 0
                        ? "K"
                        : Number(dataState?.D1) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB1}</td>
                    <td>{dataState?.AKUN1}</td>
                    <td>{dataState?.CC1}</td>
                    <td>{dataState?.KOMP1}</td>
                    <td>{dataState?.AKT1}</td>
                    <td>{dataState?.KET1}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K1) > 0
                            ? Number(dataState?.K1)
                            : Number(dataState?.D1) > 0
                            ? Number(dataState?.D1)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB2 !== null &&
                        dataState?.NOTB2 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 2,
                            NOTB: dataState?.NOTB2,
                            AKUN: dataState?.AKUN2,
                            CC: dataState?.CC2,
                            KOMP: dataState?.KOMP2,
                            AKT: dataState?.AKT2,
                            KET: dataState?.KET2,
                            K: dataState?.K2,
                            D: dataState?.D2,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K2) > 0
                        ? "K"
                        : Number(dataState?.D2) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB2}</td>
                    <td>{dataState?.AKUN2}</td>
                    <td>{dataState?.CC2}</td>
                    <td>{dataState?.KOMP2}</td>
                    <td>{dataState?.AKT2}</td>
                    <td>{dataState?.KET2}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K2) > 0
                            ? Number(dataState?.K2)
                            : Number(dataState?.D2) > 0
                            ? Number(dataState?.D2)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB3 !== null &&
                        dataState?.NOTB3 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 3,
                            NOTB: dataState?.NOTB3,
                            AKUN: dataState?.AKUN3,
                            CC: dataState?.CC3,
                            KOMP: dataState?.KOMP3,
                            AKT: dataState?.AKT3,
                            KET: dataState?.KET3,
                            K: dataState?.K3,
                            D: dataState?.D3,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K3) > 0
                        ? "K"
                        : Number(dataState?.D3) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB3}</td>
                    <td>{dataState?.AKUN3}</td>
                    <td>{dataState?.CC3}</td>
                    <td>{dataState?.KOMP3}</td>
                    <td>{dataState?.AKT3}</td>
                    <td>{dataState?.KET3}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K3) > 0
                            ? Number(dataState?.K3)
                            : Number(dataState?.D3) > 0
                            ? Number(dataState?.D3)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB4 !== null &&
                        dataState?.NOTB4 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 4,
                            NOTB: dataState?.NOTB4,
                            AKUN: dataState?.AKUN4,
                            CC: dataState?.CC4,
                            KOMP: dataState?.KOMP4,
                            AKT: dataState?.AKT4,
                            KET: dataState?.KET4,
                            K: dataState?.K4,
                            D: dataState?.D4,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K4) > 0
                        ? "K"
                        : Number(dataState?.D4) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB4}</td>
                    <td>{dataState?.AKUN4}</td>
                    <td>{dataState?.CC4}</td>
                    <td>{dataState?.KOMP4}</td>
                    <td>{dataState?.AKT4}</td>
                    <td>{dataState?.KET4}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K4) > 0
                            ? Number(dataState?.K4)
                            : Number(dataState?.D4) > 0
                            ? Number(dataState?.D4)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB5 !== null &&
                        dataState?.NOTB5 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 5,
                            NOTB: dataState?.NOTB5,
                            AKUN: dataState?.AKUN5,
                            CC: dataState?.CC5,
                            KOMP: dataState?.KOMP5,
                            AKT: dataState?.AKT5,
                            KET: dataState?.KET5,
                            K: dataState?.K5,
                            D: dataState?.D5,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K5) > 0
                        ? "K"
                        : Number(dataState?.D5) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB5}</td>
                    <td>{dataState?.AKUN5}</td>
                    <td>{dataState?.CC5}</td>
                    <td>{dataState?.KOMP5}</td>
                    <td>{dataState?.AKT5}</td>
                    <td>{dataState?.KET5}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K5) > 0
                            ? Number(dataState?.K5)
                            : Number(dataState?.D5) > 0
                            ? Number(dataState?.D5)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB6 !== null &&
                        dataState?.NOTB6 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 6,
                            NOTB: dataState?.NOTB6,
                            AKUN: dataState?.AKUN6,
                            CC: dataState?.CC6,
                            KOMP: dataState?.KOMP6,
                            AKT: dataState?.AKT6,
                            KET: dataState?.KET6,
                            K: dataState?.K6,
                            D: dataState?.D6,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K6) > 0
                        ? "K"
                        : Number(dataState?.D6) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB6}</td>
                    <td>{dataState?.AKUN6}</td>
                    <td>{dataState?.CC6}</td>
                    <td>{dataState?.KOMP6}</td>
                    <td>{dataState?.AKT6}</td>
                    <td>{dataState?.KET6}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K6) > 0
                            ? Number(dataState?.K6)
                            : Number(dataState?.D6) > 0
                            ? Number(dataState?.D6)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB7 !== null &&
                        dataState?.NOTB7 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 7,
                            NOTB: dataState?.NOTB7,
                            AKUN: dataState?.AKUN7,
                            CC: dataState?.CC7,
                            KOMP: dataState?.KOMP7,
                            AKT: dataState?.AKT7,
                            KET: dataState?.KET7,
                            K: dataState?.K7,
                            D: dataState?.D7,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K7) > 0
                        ? "K"
                        : Number(dataState?.D7) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB7}</td>
                    <td>{dataState?.AKUN7}</td>
                    <td>{dataState?.CC7}</td>
                    <td>{dataState?.KOMP7}</td>
                    <td>{dataState?.AKT7}</td>
                    <td>{dataState?.KET7}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K7) > 0
                            ? Number(dataState?.K7)
                            : Number(dataState?.D7) > 0
                            ? Number(dataState?.D7)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB8 !== null &&
                        dataState?.NOTB8 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 8,
                            NOTB: dataState?.NOTB8,
                            AKUN: dataState?.AKUN8,
                            CC: dataState?.CC8,
                            KOMP: dataState?.KOMP8,
                            AKT: dataState?.AKT8,
                            KET: dataState?.KET8,
                            K: dataState?.K8,
                            D: dataState?.D8,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K8) > 0
                        ? "K"
                        : Number(dataState?.D8) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB8}</td>
                    <td>{dataState?.AKUN8}</td>
                    <td>{dataState?.CC8}</td>
                    <td>{dataState?.KOMP8}</td>
                    <td>{dataState?.AKT8}</td>
                    <td>{dataState?.KET8}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K8) > 0
                            ? Number(dataState?.K8)
                            : Number(dataState?.D8) > 0
                            ? Number(dataState?.D8)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB9 !== null &&
                        dataState?.NOTB9 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 9,
                            NOTB: dataState?.NOTB9,
                            AKUN: dataState?.AKUN9,
                            CC: dataState?.CC9,
                            KOMP: dataState?.KOMP9,
                            AKT: dataState?.AKT9,
                            KET: dataState?.KET9,
                            K: dataState?.K9,
                            D: dataState?.D9,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K9) > 0
                        ? "K"
                        : Number(dataState?.D9) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB9}</td>
                    <td>{dataState?.AKUN9}</td>
                    <td>{dataState?.CC9}</td>
                    <td>{dataState?.KOMP9}</td>
                    <td>{dataState?.AKT9}</td>
                    <td>{dataState?.KET9}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K9) > 0
                            ? Number(dataState?.K9)
                            : Number(dataState?.D9) > 0
                            ? Number(dataState?.D9)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        dataState?.NOTB10 !== null &&
                        dataState?.NOTB10 !== ""
                      ) {
                        setOpenModalSelect(!openModalSelect);
                        setDataModalSelect([
                          {
                            INDEX: 10,
                            NOTB: dataState?.NOTB10,
                            AKUN: dataState?.AKUN10,
                            CC: dataState?.CC10,
                            KOMP: dataState?.KOMP10,
                            AKT: dataState?.AKT10,
                            KET: dataState?.KET10,
                            K: dataState?.K10,
                            D: dataState?.D10,
                          },
                        ]);
                      }
                    }}
                  >
                    <td>
                      {Number(dataState?.K10) > 0
                        ? "K"
                        : Number(dataState?.D10) > 0
                        ? "D"
                        : ""}
                    </td>
                    <td>{dataState?.NOTB10}</td>
                    <td>{dataState?.AKUN10}</td>
                    <td>{dataState?.CC10}</td>
                    <td>{dataState?.KOMP10}</td>
                    <td>{dataState?.AKT10}</td>
                    <td>{dataState?.KET10}</td>
                    <td>
                      <NumberFormat
                        value={
                          Number(dataState?.K10) > 0
                            ? Number(dataState?.K10)
                            : Number(dataState?.D10) > 0
                            ? Number(dataState?.D10)
                            : ""
                        }
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="7" style={{ textAlign: "right" }}>
                      <strong>TOTAL</strong>
                    </td>
                    <td>
                      <NumberFormat
                        value={Number(dataState?.Total)}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
              {/* <Row>
        <Col lg="6" md="6" sm="12">
          <p>
            <strong>{"*) "}</strong>Nilai TB - Nilai Nota Kredit
          </p>
        </Col>
        <Col lg="6" md="6" sm="12"> */}
              <ButtonGroup className="float-right">
                <Button
                  color="primary"
                  onClick={() => {
                    setLoadingSave(true);
                    handleSimpan(false);
                  }}
                  disabled={loadingSave}
                >
                  {loadingSave ? "Loading..." : "Ubah"}
                </Button>
                &nbsp;
                <Button
                  color="success"
                  onClick={() => {
                    setLoadingSave(true);
                    handleSimpan(true);
                  }}
                  disabled={loadingSave}
                >
                  {loadingSave ? "Loading..." : "Ubah & Print"}
                </Button>
              </ButtonGroup>
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
}
